module.exports = __webpack_public_path__ + "img/electronic_use_selected.e19f0e5b.svg";